import type { ThemeConfig } from "antd";

// Colores centralizados del proyecto
export const colors = {
  primary: {
    main: "#0891b2", // cyan-600
    light: "#06b6d4", // cyan-500
    dark: "#0e7490", // cyan-700
    lighter: "#22d3ee", // cyan-400
  },
  secondary: {
    main: "#1f2937", // gray-800
    light: "#374151", // gray-700
    dark: "#111827", // gray-900
  },
  accent: {
    yellow: "#eab308", // yellow-500
    green: "#22c55e", // green-500
    red: "#ef4444", // red-500
  },
  background: {
    main: "#ffffff",
    dark: "#1f2937",
  },
};

// Configuración del theme de Ant Design
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary.main,
    colorBgContainer: colors.background.main,
    borderRadius: 8,
    fontSize: 14,
    colorText: "#1f2937",
    colorTextSecondary: "#6b7280",
  },
  components: {
    Button: {
      colorPrimary: colors.primary.main,
      algorithm: true,
      controlHeight: 40,
      fontWeight: 600,
    },
    Input: {
      controlHeight: 40,
      borderRadius: 6,
    },
    Card: {
      borderRadiusLG: 12,
    },
  },
};
